import React, { Component, createRef } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { cadenas } from '../Utils/cadenas';
import Papa from 'papaparse';
import { Toast } from 'primereact/toast';

/**
 * Definir las propiedades que recibe el componente.
 */
interface Props {
    settearState: (id:string, value:any) => void;
    stateParent: any
}

/**
 * Definir el estado del componente.
 */
interface State {
    [key:string]:any;
}
/**
 * @class
 * Componente que permite generar el formulario de registro 
 * para la pantalla de Usuarios.
 */
class CargaCatalogo extends Component<Props, State> {
  /**
   * @function
   * Función principal para renderizar el contenido del componente.
   */
  private dataTable2: any;

  private toast: any;
  constructor(props: any) {
    super(props);
    this.dataTable2 = createRef();

    this.state = {
      data: [],
      errores: [],
    };
    this.toast = createRef();
  }
  handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    this.setState({ errores: [] });
    this.setState({ data: [] });
    this.props.stateParent.parseData = [];
    this.props.stateParent.parseDataError = [];
    if (file) {
      Papa.parse(file, {
        header: true, // If your CSV has a header row
        dynamicTyping: false, // Attempt to convert values to numbers, booleans, etc.
        complete: (results) => {
          let items = Array();
          let itemsError = Array();
          if (results.data.length > 0) {
            results.data.forEach((d: any) => {
              if (d.Codigo !== '') {
                console.log("codigo:" + d.Codigo.padStart(2, 0));
                let itemerror = {
                  codigo: '' + (this.props.stateParent.type > 2 ? d.Codigo : d.Codigo.padStart(2, 0)),
                  nombre: d.Nombre,
                  estado: '' + d.Estado,
                  error: '',
                };
                if (
                  !isNaN(parseInt(d.Codigo)) &&
                  ((this.props.stateParent.type < 3 && d.Codigo.length <= 2) ||
                    (this.props.stateParent.type === 3 && d.Codigo.length === 1))
                ) {
                  if (!isNaN(parseInt(d.Estado)) && d.Estado.length === 1 && parseInt(d.Estado) < 2) {
                    if (d.Nombre.length <= 200) {
                      let item = {
                        codigo: '' + (this.props.stateParent.type > 2 ? d.Codigo : d.Codigo.padStart(2, 0)),
                        nombre: d.Nombre,
                        estado: '' + d.Estado,
                      };
                      items.push(item);
                    } else {
                      itemerror.error = cadenas.CATALOGO_ERROR_NOMBRE;
                      itemsError.push(itemerror);
                    }
                  } else {
                    itemerror.error = cadenas.CATALOGO_ERROR_ESTADO;
                    itemsError.push(itemerror);
                  }
                } else {
                  itemerror.error =
                    this.props.stateParent.type < 3
                      ? cadenas.CATALOGO_ERROR_CODIGO
                      : cadenas.CATALOGO_ERROR_CODIGO_SEVERIDAD;
                  itemsError.push(itemerror);
                }
              }
            });
            this.props.stateParent.parseData = items;
            this.props.stateParent.parseDataError = itemsError;
            console.log(this.props.stateParent.parseData.length);
            this.setState({ errores: itemsError });
            if (items.length < 1) {
              document.getElementById('cargarButton')?.setAttribute('disabled', 'true');
              this.props.stateParent.parseDataError = [];
              this.setState({ errores: [] });
              document.getElementById('cargarButton')?.setAttribute('disabled', 'true');
              this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_CARGA_VACIA);
            } else {
              console.log(document.getElementById('cargarButton'));
              document.getElementById('cargarButton')?.removeAttribute('disabled');
              this.setState({ data: items });
            }
            if (itemsError.length > 0) {
              document.getElementById('cargarButton')?.setAttribute('disabled', 'true');
              this.setState({ data: [] });
              this.props.stateParent.parseData = [];
            }
          } else {
            this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.CATALOGO_CARGA_VACIA);
          }
        },
        error: (error) => {
          console.error('Error parsing CSV:', error);
        },
      });
    }
  };
  /**
   * Mostrar la notificación de tipo Growl (componente del framewrok Prime React).
   * @param {string} type Tipo de la notificación.
   * @param {string} title Título de la notificación.
   * @param {string} message Mensaje de la notificación.
   */
  showNotificacion(type: string, title: string, message: string) {
    
    this.toast.current?.show({
      severity: type,
      summary: title,
      detail: message,
    });
  }
  render() {
    return (
      <div className="p-fluid">
        <Toast ref={this.toast} />
        <div>
          <div className="p-field p-grid">
            <label className="p-col-12 p-md-4">{cadenas.CATALOGO_CARGA}: *</label>
            <div className="p-col-12 p-md-8">
              <input type="file" accept=".csv" onChange={this.handleFileChange} />
            </div>
          </div>
          <div
            className="p-field p-grid"
            style={{ display: this.state.errores.length === 0 && this.state.data.length > 0 ? 'block' : 'none' }}
          >
            <label className="p-col-12 p-md-12">{cadenas.CATALOGO_CARGA_LISTA}</label>
          </div>
          <div className="p-field p-grid" style={{ display: this.state.errores.length > 0 ? 'block' : 'none' }}>
            <label className="p-col-12 p-md-12">{cadenas.CATALOGO_CARGA_ERRORES}</label>
            <div className="p-col-12 p-md-12">
              <DataTable
                filterDisplay="row"
                value={this.state.errores}
                paginator={true}
                rows={5}
                responsiveLayout="scroll"
                ref={this.dataTable2}
                emptyMessage={cadenas.DATATABLE_VACIO}
              >
                <Column
                  showFilterMenu={false}
                  filterMatchMode="contains"
                  field="codigo"
                  header={cadenas.CATALOGO_CODIGO}
                  filter={true}
                  sortable={true}
                />
                <Column
                  showFilterMenu={false}
                  filterMatchMode="contains"
                  field="nombre"
                  header={cadenas.CATALOGO_NOMBRE}
                  filter={true}
                  sortable={true}
                />
                <Column
                  body={(rowData: any, column: any) => rowData.estado}
                  header={cadenas.CATALOGO_ESTADO}
                  filter={true}
                  field="estado"
                  sortable={true}
                  showFilterMenu={false}
                  filterMatchMode="contains"
                />
                <Column
                  showFilterMenu={false}
                  filterMatchMode="contains"
                  field="error"
                  header={cadenas.ERROR_TITULO}
                  filter={true}
                  sortable={true}
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default CargaCatalogo;
